
import Icon from '@/ui-kit/components/icon';
import { IconType } from '@/ui-kit/components/icon/enums';
import routes from '@/constants/routes';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';

export default {
  name: 'NewOfferComponent',
  components: {
    Icon,
  },
  data: () => ({
    IconType,
    StyleSizeType,
    StyleColorSchemeType,
  }),
  methods: {
    showNewOffer() {
      this.$router.push(routes.offersManagementSeller);
    },
  },
};
